import React from 'react';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './BibItemField.scss';

export default function BibItemField({ field, value }) {
  if (!value) {
    return null;
  }

  return (
    <div className="cp-bib-item-field">
      <span className="field-label">{field}:</span>
      <span className="field-value">{value}</span>
    </div>
  );
}

BibItemField.propTypes = {
  field: childrenShape,
  value: childrenShape
};
